import { IBookingTableJoin } from './types';
import { IBooking, ITableItem, ILayout } from 'shared-types/index';

const NS = 'TableJoinService';

export const JOIN_PREFIX = 'join_';

class TableJoinService {
  convertToManualJoin(selectedTableIds: string[], tableList: ITableItem[], isManualJoin: boolean) {
    // using the first selectedTableId because if using the layout-based table join, which is prefixed with 'join_', there can only be one selected.
    const firstSelectedTableId = selectedTableIds[0];
    if (!isManualJoin && firstSelectedTableId && firstSelectedTableId.indexOf(JOIN_PREFIX) === 0) {
      // if table join is selected (layout level join), converts it to a manual join
      const selectedTableJoin = tableList.find(({ _id }) => firstSelectedTableId === _id);
      return selectedTableJoin.tablesList;
    } else {
      return tableList.filter(({ _id }) => selectedTableIds.includes(_id));
    }
  }

  setTableJoinForBooking(booking: IBookingTableJoin, layouts: ILayout[]): void {
    const newTableJoin = this.getTableJoinForBooking(booking, layouts);
    if (newTableJoin) {
      booking.tableJoin = newTableJoin as ITableItem;
    }
  }

  getTableJoinForBooking(booking: IBooking, layouts: ILayout[]): ITableItem | {} {
    let newTableJoin: ITableItem | {} = {};

    // find the layout of the table
    const layout: ILayout = this.getLayoutByTable(booking, layouts);

    if (layout && layout.tablesJoins && layout.tablesJoins.length) {
      const numberOfTablesToMatch: number = booking.tables.length;
      for (let tbIndex = layout.tablesJoins.length - 1; tbIndex >= 0; tbIndex--) {
        const tableJoin: ITableItem = layout.tablesJoins[tbIndex];
        let matched: number = 0;

        if (numberOfTablesToMatch === tableJoin.tables.length) {
          // checks that each table exists in the tableJoin
          for (let u = 0; u < numberOfTablesToMatch; u++) {
            const table: ITableItem = booking.tables[u];
            const tableFound: number = tableJoin.tables.indexOf(table._id);
            if (tableFound !== -1) {
              matched++;
            }
          }
          // checks for exact table match in tableJoin
          if (numberOfTablesToMatch === matched) {
            // join found
            newTableJoin = tableJoin;
            break;
          }
        }
      }
    }

    return newTableJoin;
  }

  getLayoutByTable(booking: IBooking, layouts: ILayout[]): ILayout {
    // find the layout of the table
    const firstTable = booking.tables[0];
    let layout: ILayout;
    for (let l = layouts.length - 1; l >= 0; l--) {
      layout = layouts[l];
      const tableIndex = layout.tables.indexOf(firstTable._id);
      if (tableIndex !== -1) {
        break;
      }
    }
    return layout;
  }
}

const instance = new TableJoinService();
export default instance as TableJoinService;
